module.exports = __webpack_public_path__ + "img/badge-large_tranparent.88d6ba6f.png";